import { useContext, useEffect, useState } from "react";
import ModalListadoSolicitarRegistro from "./ModalListadoSolicitarRegistro";
import InputTextCustomized from "../../../../ui/kit-mdtw/InputTextCustomized";
import DropDownListCustomized from "../../../../ui/kit-mdtw/DropDownListCustomized";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import { IOptionDropDownList } from "../../../../../interfaces/IDropDownList";
import "./ModalSolicitarRegistro.css";

interface IModalSolicitarCandidato {
  rut: any[];
  solicitudes: any;
  setSolicitudes: Function;
  handleClickSolicitarCandidato: Function;
  onChangeBack: Function;
  onSelectProceso: Function;
  onComentario?: Function;
  candidates?: any[];
  masivo?: boolean;
}

export default (props: IModalSolicitarCandidato) => {
  const { rut, solicitudes, setSolicitudes, handleClickSolicitarCandidato, onChangeBack, onSelectProceso, onComentario, candidates, masivo } =
    props;
  const { listProcesosActivos, getBusquedaProcesos, token } = useContext(SeleccionContext);

  const [formComentario, setFormComentario] = useState<any>({ comentario: undefined });

  const [destinoMasivoActive, setDestinoMasivoActive] = useState(false);
  const [formDestinoMasivo, setFormDestinoMasivo] = useState<any>({ procesoDestino: undefined });
  const [procesoOptions, setProcesoOptions] = useState<IOptionDropDownList[]>([]);

  const [comentarioMasivoActive, setComentarioMasivoActive] = useState(false);
  const [formComentarioMasivo, setFormComentarioMasivo] = useState<any>({ comentario: undefined });

  useEffect(() => {
    if (!masivo) {
      onComentario?.(formComentario.comentario?.value ?? "");
    }
  }, [formComentario]);

  useEffect(() => {
    if (masivo && listProcesosActivos?.data) {
      const options: IOptionDropDownList[] = [];
      listProcesosActivos.data.forEach(({ clienteNombre, grupos }: any) => {
        grupos.forEach(({ procesos }: any) => {
          procesos.forEach(({ busquedaId, cargoNombre }: any) => {
            options.push({
              name: `${busquedaId} · ${clienteNombre} · ${cargoNombre}`,
              code: busquedaId,
            });
          });
        });
      });
      setProcesoOptions(options);
    } else if (masivo && token) {
      getBusquedaProcesos({ token, filtros: { tipoProceso: "MASIVO" }, setIsErrorTable: () => {} });
    }
  }, [listProcesosActivos, masivo]);

  useEffect(() => {
    if (!masivo) return;
    if (destinoMasivoActive) {
      onSelectProceso(formDestinoMasivo.procesoDestino?.value?.code);
    } else {
      onSelectProceso(undefined);
    }
  }, [formDestinoMasivo, destinoMasivoActive]);

  useEffect(() => {
    if (!masivo) return;
    if (comentarioMasivoActive) {
      onComentario?.(formComentarioMasivo.comentario?.value ?? "");
    } else {
      onComentario?.("");
    }
  }, [formComentarioMasivo, comentarioMasivoActive]);

  const procesoDestinoMasivo = destinoMasivoActive
    ? formDestinoMasivo.procesoDestino?.value?.code
    : undefined;

  const comentarioMasivoValue = comentarioMasivoActive
    ? (formComentarioMasivo.comentario?.value ?? "")
    : undefined;

  return (
    <>
      {masivo && (
        <div className="solicitar-masivo-controls">
          <div className="solicitar-masivo-item">
            <label className="solicitar-masivo-checkbox-label">
              <input
                type="checkbox"
                checked={destinoMasivoActive}
                onChange={(e) => setDestinoMasivoActive(e.target.checked)}
                className="solicitar-masivo-checkbox"
              />
              <span className="solicitar-masivo-switch" />
              Destino masivo
            </label>
            <div className={`solicitar-masivo-field${destinoMasivoActive ? " visible" : ""}`}>
              <div>
                <DropDownListCustomized
                  list={procesoOptions}
                  placeholder="Seleccione proceso destino"
                  errorPosition="down"
                  onValueChange={setFormDestinoMasivo}
                  onPermaValues={formDestinoMasivo}
                  onPropertyChange="procesoDestino"
                />
              </div>
            </div>
          </div>
          <div className="solicitar-masivo-item">
            <label className="solicitar-masivo-checkbox-label">
              <input
                type="checkbox"
                checked={comentarioMasivoActive}
                onChange={(e) => setComentarioMasivoActive(e.target.checked)}
                className="solicitar-masivo-checkbox"
              />
              <span className="solicitar-masivo-switch" />
              Comentario masivo
            </label>
            <div className={`solicitar-masivo-field${comentarioMasivoActive ? " visible" : ""}`}>
              <div>
                <InputTextCustomized
                  layer="Comentario para todos los registros (opcional)"
                  placeholder="¿Por qué solicitas estos candidatos?"
                  required={false}
                  errorPosition="down"
                  onValueChange={setFormComentarioMasivo}
                  onPermaValues={formComentarioMasivo}
                  onPropertyChange="comentario"
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <section className="content-table-restaurar">
        <table className="table-restaurar w-100" style={{ minWidth: masivo ? "900px" : "680px" }}>
          <thead className="thead-table-restaurar">
            <tr className="tr-table-restaurar">
              <th className="td-table-restaurar">Rut</th>
              <th className="td-table-restaurar">Nombre</th>
              <th className="td-table-restaurar">Fecha Postulación</th>
              <th className="td-table-restaurar">Reclutador</th>
              <th className="td-table-restaurar">ID Origen</th>
              <th className="td-table-restaurar">ID Destino</th>
              {masivo && <th className="td-table-restaurar">Comentario</th>}
            </tr>
          </thead>
          <tbody className="tbody-table-restaurar">
            {rut &&
              rut.map((item: any, index: number) => (
                <ModalListadoSolicitarRegistro
                  rut={item}
                  solicitudes={solicitudes}
                  setSolicitudes={setSolicitudes}
                  handleClickSolicitarCandidato={handleClickSolicitarCandidato}
                  onChangeBack={onChangeBack}
                  onSelectProceso={onSelectProceso}
                  candidateData={candidates?.[index]}
                  masivo={masivo}
                  destinoMasivoActive={destinoMasivoActive}
                  procesoDestinoMasivo={procesoDestinoMasivo}
                  comentarioMasivo={comentarioMasivoValue}
                />
              ))}
          </tbody>
        </table>
      </section>
      {!masivo && (
        <div className="solicitar-comentario-wrapper">
          <InputTextCustomized
            layer="Comentario (opcional)"
            placeholder="¿Por qué solicitas este candidato?"
            required={false}
            errorPosition="down"
            onValueChange={setFormComentario}
            onPermaValues={formComentario}
            onPropertyChange="comentario"
          />
        </div>
      )}
    </>
  );
};
